<template>
  <label
    :class="{
      'srp-checkbox': true,

      'srp-checkbox--disabled': props.isDisabled,

      'srp-checkbox--tiny': props.size === 'tiny',
      'srp-checkbox--small': props.size === 'small',
      'srp-checkbox--medium': props.size === 'medium',
      'srp-checkbox--big': props.size === 'big',

      'srp-checkbox--with-halo': props.isWithHalo,
      'srp-checkbox--with-hover-opacity-effect': !props.isWithHalo,
    }"
  >
    <span class="srp-checkbox__checkbox-wrap">
      <slot name="input" />
      <span
        v-if="props.isWithHalo"
        :class="{
          'srp-checkbox__halo-bg': true,
          'srp-checkbox__halo-bg--white': props.haloColor === 'white',

          'srp-checkbox__halo-bg--fill-solid': props.fill === 'solid',
          'srp-checkbox__halo-bg--fill-outlined': props.fill === 'outlined',
        }"
      ></span>
    </span>
    <span
      :class="{
        'srp-checkbox__text': true,
        'srp-checkbox__text--white-space-nowrap': props.whiteSpace === 'nowrap',

        'srp-checkbox__text--tiny': props.size === 'tiny',
        'srp-checkbox__text--small': props.size === 'small',
        'srp-checkbox__text--medium': props.size === 'medium',
        'srp-checkbox__text--big': props.size === 'big',
      }"
    >
      <slot name="text" />
    </span>
  </label>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    isWithHalo?: boolean;
    fill?: "solid" | "outlined";
    haloColor?: "gray" | "white";
    whiteSpace?: "wrap" | "nowrap";
    size?: "tiny" | "small" | "medium" | "big";
    isDisabled?: boolean;
  }>(),
  {
    isWithHalo: true,
    fill: "solid",
    haloColor: "gray",
    whiteSpace: "nowrap",
    size: "small",
    isDisabled: false,
  }
);

const emit = defineEmits<{
  (e: "clickWithNoBubbling"): void;
}>();
</script>

<style scoped lang="scss">
// Srp checkbox ===============================================================
.srp-checkbox {
  width: auto !important;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  position: relative;
  z-index: 0;
  user-select: none;
  cursor: pointer;

  &::after {
    content: "";
    width: calc(100% + 8px);
    height: calc(100% + 8px);
    position: absolute;
    inset: 50% auto auto 50%;
    z-index: -1;
    transform: translate(-50%, -50%);
  }

  &--disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  // Size
  &--tiny {
  }

  &--small {
    height: 33px;
    padding: 0 !important;
  }

  &--medium {
    height: 41px;
    padding: 0 !important;
  }

  &--big {
    height: 52px;
    padding: 0 !important;
  }

  &--with-halo {
    min-height: 32px;
    padding: 6px 11px 7px !important;
  }

  &__halo-bg {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    position: absolute;
    inset: 0 auto auto 0;
    z-index: -1;
    background: rgba(0, 0, 0, 0.1);
    transition:
      width 0.05s ease-in-out,
      left 0.05s ease-in-out,
      background 0.05s ease-in-out;

    &--white {
      background: rgba(255, 255, 255, 1);
    }

    &--fill-solid {
    }
    &--fill-outlined {
      border: 1px rgba(0, 0, 0, 0.15) solid;
      background: rgba(255, 255, 255, 1);
    }
  }

  :deep(input[type="checkbox"]),
  :deep(input[type="radio"]) {
    margin: 0 !important;
    position: relative;
    top: -1px;
  }

  input[type="checkbox"]:checked + &__halo-bg,
  input[type="radio"]:checked + &__halo-bg {
    background: rgba(0, 0, 0, 0.2);
  }

  input[type="checkbox"]:checked + &__halo-bg--white,
  input[type="radio"]:checked + &__halo-bg--white {
    background: rgba(255, 255, 255, 1);
  }

  input[type="checkbox"]:checked + &__halo-bg--fill-outlined,
  input[type="radio"]:checked + &__halo-bg--fill-outlined {
    background: rgba(255, 255, 255, 1);
  }

  &:hover &__halo-bg {
    width: calc(100% + 6px);
    left: -3px;
  }

  &__checkbox-wrap {
    height: 15px;
    margin: 2px 6px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;

    :deep(input) {
      width: 15px;
      height: 15px;
      cursor: pointer;
    }
  }

  &__text {
    padding-bottom: 1px;
    color: #5b5b5b;
    font: 14px/15px sans-serif;

    &--white-space-nowrap {
      white-space: nowrap;
    }

    &--tiny {
    }
    &--small {
    }
    &--medium {
    }
    &--big {
    }
  }

  &--with-hover-opacity-effect:hover &__text {
    opacity: 0.7;
  }
}
</style>
